module.exports = __webpack_public_path__ + "img/miami.8d166e6c.png";